import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import subheader from './modules/subheader'
import filter from './modules/filter'
import groupAbility from './modules/groupAbility'
import syncPrestaNode from './modules/syncPrestaNode'
import entry from './modules/entry'
import lang from './modules/lang'
import notification from './modules/notification'
import photo from './modules/photo'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    groupAbility,
    syncPrestaNode,
    subheader,
    filter,
    entry,
    lang,
    notification,
    photo
  }
})
